import { useState } from 'react';
import WeeklyShipService from './WeeklyShipService';
import { useSelector } from 'react-redux';

const useManageCompositeJob = () => {
  const [compositeJob, setCompositeJob] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const shopName = useSelector((state) => state.shop.name);

  const getCompositeJobByShipDate = async (shipDateId) => {
    if (!shipDateId || !shopName) return;
    
    setIsLoading(true);
    setError(null);
    try {
      const response = await WeeklyShipService.getCompositeJobByShipDate(shipDateId, shopName);
      setCompositeJob(response.data || null);
      setIsLoading(false);
      return response.data || null;
    } catch (err) {
      console.error('Error getting composite job by ship date:', err);
      setError(err.response?.data?.message || 'Failed to get composite jobs');
      setIsLoading(false);
      setCompositeJob(null);
      return null;
    }
  };

  const generateComposite = async (shipDateId) => {
    if (!shipDateId || !shopName) {
      setError('Ship date and shop name are required');
      return false;
    }

    setIsLoading(true);
    setError(null);
    try {
      await WeeklyShipService.generateComposite(shipDateId, shopName);
      setIsLoading(false);
      return true;
    } catch (err) {
      console.error('Error generating composite:', err);
      setError(err.response?.data?.message || 'Failed to generate composite');
      setIsLoading(false);
      return false;
    }
  };

  const downloadCompositeZip = async (shipDateId) => {
    if (!shipDateId || !shopName) {
      setError('Ship date and shop name are required');
      return false;
    }

    setIsLoading(true);
    setError(null);
    try {
      const response = await WeeklyShipService.downloadCompositeZip(shipDateId, shopName);
      
      // Create blob link to download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `composite-${shipDateId}.zip`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      setIsLoading(false);
      return true;
    } catch (err) {
      console.error('Error downloading composite zip:', err);
      setError(err.response?.data?.message || 'Failed to download composite zip');
      setIsLoading(false);
      return false;
    }
  };

  return {
    compositeJob,
    isLoading,
    error,
    getCompositeJobByShipDate,
    generateComposite,
    downloadCompositeZip,
    setCompositeJob
  };
};

export default useManageCompositeJob;

